'use strict';

/* global yith_wcaf */

import { $, labels } from '../../src/globals.js';
import { initConfirm } from './modules/confirm';
import YITH_WCAF_Add_Affiliate_Modal from './modules/yith-wcaf-add-affiliate-modal';
import YITH_WCAF_Admin_Info_Modal from './modules/yith-wcaf-admin-info-modal';
import YITH_WCAF_Admin_Tabs from './modules/yith-wcaf-admin-tabs';
import YITH_WCAF_Link_Generator from '../../src/modules/yith-wcaf-link-generator';
import YITH_WCAF_Admin_Panel from './modules/yith-wcaf-admin-panel';

class YITH_WCAF_Affiliates extends YITH_WCAF_Admin_Panel {
	constructor() {
		const $containers = $( '#yith_wcaf_panel_affiliates' ).add(
			'#yith_wcaf_panel_affiliates-list'
		);

		super( $containers );

		// list.
		this.initConfirm();
		this.initAddModal();
		this.initMessageModals();

		// details.
		this.initTabs();
		this.initLinkGenerator();
	}

	initConfirm() {
		initConfirm();
	}

	initAddModal() {
		const $modalOpener = $( '.yith-add-button' );

		if ( ! $modalOpener.length ) {
			return;
		}

		new YITH_WCAF_Add_Affiliate_Modal( $modalOpener );
	}

	initMessageModals() {
		const $context = this.$container;

		if ( ! $context.length ) {
			return;
		}

		const $disableAnchor = $( '.disable', $context ).add(
				'#doaction',
				$context
			),
			$banAnchor = $( '.ban', $context ).add( '#doaction', $context ),
			getModalData = ( modal ) => {
				return function () {
					const $opener = this.$target,
						$row = $opener.closest( 'tr.affiliate-item' );

					let data = {
						affiliates: [],
					};

					if ( $row.length ) {
						// single affiliate; use full name
						data.affiliates.push( {
							fullName: $row.data( 'full_name' ),
						} );
					} else {
						// many affiliates; use count
						const $selected = $( '.item-selector' ).filter(
							':checked'
						);

						$selected.get().forEach( ( selected ) => {
							const $selecetdRow = $( selected ).closest( 'tr' );

							data.affiliates.push( {
								fullName: $selecetdRow.data( 'full_name' ),
							} );
						} );
					}

					return data;
				};
			},
			shouldOpenModal = ( modal ) => {
				return function () {
					const $opener = this.$target;

					if ( $opener.hasClass( modal ) ) {
						return true;
					} else if ( $opener.is( '#doaction' ) ) {
						const $bulkActionsSelect = $opener.siblings(
							'[name="action"]'
						);

						if ( $bulkActionsSelect.length ) {
							const bulkAction = $bulkActionsSelect.val();

							return modal === bulkAction;
						}
					}

					return false;
				};
			};

		if ( $banAnchor.length && ! yith_wcaf?.ban_global_message_enabled ) {
			new YITH_WCAF_Admin_Info_Modal( $banAnchor, {
				title: labels?.ban_modal_title,
				template: 'yith-wcaf-ban-affiliate-modal',
				data: getModalData( 'ban' ),
				shouldOpen: shouldOpenModal( 'ban' ),
				width: 350,
			} );
		}

		if (
			$disableAnchor.length &&
			! yith_wcaf?.reject_global_message_enabled
		) {
			new YITH_WCAF_Admin_Info_Modal( $disableAnchor, {
				title: labels?.reject_modal_title,
				template: 'yith-wcaf-disable-affiliate-modal',
				data: getModalData( 'disable' ),
				shouldOpen: shouldOpenModal( 'disable' ),
				width: 350,
			} );
		}
	}

	initTabs() {
		const $tabWrapper = $( '#affiliate_related_items' );

		if ( ! $tabWrapper.length ) {
			return;
		}

		new YITH_WCAF_Admin_Tabs( $tabWrapper );
	}

	initLinkGenerator() {
		const $linkGenerator = $( '#affiliate_url' );

		if ( ! $linkGenerator.length ) {
			return;
		}

		new YITH_WCAF_Link_Generator( $linkGenerator );
	}
}

$( () => new YITH_WCAF_Affiliates() );
